import {useEffect,useRef} from 'react';
import type {CitationTarget} from '@reados/contracts';
import {sourceLineRange,splitSourceLines} from '../markdown-reader';
import '../markdown-reader.css';

export function SourceText({text,target}:{text:string;target?:CitationTarget&{key:number}}){
 const selected=useRef<HTMLElement>(null),range=sourceLineRange(target),parts=splitSourceLines(text,range);
 useEffect(()=>{selected.current?.scrollIntoView({block:'center'});},[text,target?.key]);
 return <>
  {range&&!parts.range&&<div className="notice" role="status">引用行号超出当前可预览的内容。</div>}
  <pre className="markdown-source">{parts.before}{parts.range&&<mark ref={selected} data-source-line-start={parts.range.start} data-source-line-end={parts.range.end} aria-label={`引用第 ${parts.range.start}${parts.range.end===parts.range.start?'':`–${parts.range.end}`} 行`}>{parts.selected||'\u200b'}</mark>}{parts.after}{!text&&!parts.range?'（空文件）':null}</pre>
 </>;
}
